var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      class: {
        "c-table__cell__red": _vm.data.fineOrBonusFullNameCell.isRedCell,
        "c-table__cell__blue": _vm.data.fineOrBonusFullNameCell.isBlueCell,
        "c-table__cell__white":
          !_vm.data.fineOrBonusFullNameCell.isRedCell &&
          !_vm.data.fineOrBonusFullNameCell.isBlueCell,
      },
    },
    [
      _c("div", { staticClass: "c-table__cell-value" }, [
        _c("a", { attrs: { href: _vm.linkToWorker, target: "_blank" } }, [
          _vm._v(
            " " + _vm._s(_vm.data.fineOrBonusFullNameCell.workerName) + " "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }